import { Link } from "react-router-dom";

const Track = ({ song, link, img, alt, link_two, img_two, alt_two, download }) => {
    return (
        <div className="card">
            <div className="content">
                <p>{ song.title }</p>
                <small>- { song.artist } </small>
            </div>
            <img src={ song.cover } alt={ song.title }/>
            <div className={download ? "options dl" : "options"}>
                {
                download ? <a href={link}> Download </a> :
                <>
                    <Link to={link}><img src={img} alt={alt} /></Link>
                    { link_two && <Link to={link_two}><img src={img_two} alt={alt_two} /></Link> }
                </>
                }
            </div>
        </div>
    )
}


export default Track;